import request from '@/utils/request'

// 查询短信套餐订单分页
export function fetchList(query) {
  return request({
    url: '/extra/sms/order/page',
    method: 'get',
    params: query,
  })
}

// 获取单个订单详情
export function getObj(id) {
  return request({
    url: '/extra/sms/order/detail?id=' + id,
    method: 'get',
  })
}

// 单位购买短信套餐
export function addPersonalOrder(data) {
  return request({
    url: '/extra/sms/order/add/personal',
    method: 'post',
    data: data,
  })
}

// 初始化支付短信购买订单
export function initiatePayment(data) {
  return request({
    url: '/extra/sms/order/pay/initiate',
    method: 'post',
    data: data,
  })
}

// 订单支付状态
export function checkPayStatus(params) {
  return request({
    url: '/extra/sms/order/pay/status',
    method: 'get',
    params: params,
  })
}
